<app-nav></app-nav>

<div class="perfil-container">

  <!-- ================== PERFIL CARD ================== -->
  <section class="perfil-card" [class.edit-mode]="editMode">

    <div class="perfil-banner"></div>

    <div class="perfil-body">
      <div class="avatar-wrap">
        <img
          class="avatar-img"
          [src]="fotoPreview || fotoActual || 'https://cdn-icons-png.flaticon.com/512/847/847969.png'"
          alt="Foto de perfil"
        />
        <input type="file" accept="image/*" (change)="onFileSelected($event)" hidden #fileInput />
        <button
          class="btn-editar-top"
          type="button"
          [class.btn-cancelar-top]="editMode"
          (click)="editMode ? cancelarEdicion() : activarEdicion()"
        >
          <i [class]="editMode ? 'fa-solid fa-xmark btn-icon' : 'fa-solid fa-pen btn-icon'"></i>
          {{ editMode ? 'Cancelar' : 'Editar perfil' }}
        </button>
      </div>

      <div class="avatar-name">{{ form.value.nombre_usuario || '—' }}</div>
      <div class="avatar-email">{{ form.value.correo_usuario || '—' }}</div>

      <div *ngIf="mensaje" class="alerta" [ngClass]="tipoMensaje">{{ mensaje }}</div>

      <!-- ── NIVEL / PROGRESO ── -->
      <div class="nivel-wrap" *ngIf="!editMode">
        <div class="nivel-top">
          <div class="nivel-info">
            <span class="nivel-tag">{{ nivelNombre }}</span>
            <span class="nivel-pts">{{ puntosActuales }} / {{ puntosSiguiente }} pts</span>
          </div>
          <span class="nivel-badge">Nv. {{ nivelActual }}</span>
        </div>
        <div class="nivel-track">
          <div class="nivel-fill" [style.width.%]="progresoPorc"></div>
        </div>
        <div class="nivel-next">{{ puntosRestantes }} pts para {{ nombreSiguienteNivel }}</div>
      </div>

      <!-- ── ESTADÍSTICAS ── -->
      <div class="stats-grid" *ngIf="!editMode">
        <div class="stat-card">
          <span class="stat-num">{{ lugaresVisitados }}</span>
          <span class="stat-label">Visitados</span>
        </div>
        <div class="stat-card">
          <span class="stat-num">{{ resenasDadas }}</span>
          <span class="stat-label">Reseñas</span>
        </div>
        <div class="stat-card">
          <span class="stat-num">{{ municipiosExplorados }}</span>
          <span class="stat-label">Municipios</span>
        </div>
      </div>

      <!-- ── INSIGNIAS ── -->
      <ng-container *ngIf="!editMode">
        <div class="section-label">
          <i class="fa-solid fa-award"></i> Insignias obtenidas
        </div>
        <div class="badges-row">
          <div
            class="badge-item"
            *ngFor="let b of badges"
            [class.badge-locked]="!b.earned"
            [title]="b.name"
          >
            <div class="badge-icon">
              <i [class]="b.icon"></i>
            </div>
            <span class="badge-name">{{ b.name }}</span>
          </div>
        </div>
      </ng-container>

      <!-- ── MODO LECTURA ── -->
      <ng-container *ngIf="!editMode">
        <div class="section-label" style="margin-top: 20px;">
          <i class="fa-solid fa-user"></i> Datos personales
        </div>
        <div class="info-row">
          <label>Nombre</label>
          <span class="val">{{ form.value.nombre_usuario || '—' }}</span>
        </div>
        <div class="info-row">
          <label>Email</label>
          <span class="val">{{ form.value.correo_usuario || '—' }}</span>
        </div>
      </ng-container>

      <!-- ── MODO EDICIÓN ── -->
      <form [formGroup]="form" (ngSubmit)="guardar()" *ngIf="editMode">
        <div class="campo">
          <label>Nombre</label>
          <input type="text" formControlName="nombre_usuario" />
        </div>
        <div class="campo">
          <label>Email</label>
          <input type="email" formControlName="correo_usuario" />
        </div>

        <button class="btn-foto" type="button" (click)="fileInput.click()">
          <i class="fa-solid fa-camera"></i> Cambiar foto
        </button>

        <div class="divider">Cambiar contraseña</div>

        <div class="campo">
          <label>Contraseña actual</label>
          <input type="password" formControlName="password_actual" placeholder="••••••••" />
        </div>
        <div class="campo">
          <label>Nueva contraseña</label>
          <input type="password" formControlName="password_nueva" placeholder="••••••••" />
        </div>
        <div class="campo">
          <label>Confirmar contraseña</label>
          <input type="password" formControlName="password_confirmacion" placeholder="••••••••" />
        </div>

        <div class="error-msg"
          *ngIf="form.value.password_nueva && form.value.password_nueva !== form.value.password_confirmacion">
          Las contraseñas no coinciden
        </div>

        <button type="submit" class="btn-guardar" [disabled]="saving">
          <i class="fa-solid fa-floppy-disk btn-icon" *ngIf="!saving"></i>
          {{ saving ? 'Guardando...' : 'Guardar cambios' }}
        </button>
      </form>

    </div>
  </section>

  <!-- ================== HISTORIAL ================== -->
  <section class="hist-card" *ngIf="historial.length > 0">
    <div class="fav-header">
      <div class="fav-header-icon hist-icon">
        <i class="fa-solid fa-clock-rotate-left"></i>
      </div>
      <span class="fav-header-title">Últimos lugares visitados</span>
    </div>
    <div class="hist-list">
      <div class="hist-item" *ngFor="let h of historial">
        <div class="hist-thumb">
          <img *ngIf="h.imagenUrl" [src]="h.imagenUrl" [alt]="h.nombre" />
          <span *ngIf="!h.imagenUrl" class="hist-thumb__initial">{{ h.nombre[0] | uppercase }}</span>
        </div>
        <div class="hist-info">
          <div class="hist-name">{{ h.nombre }}</div>
          <div class="hist-meta">{{ h.municipio }} · {{ h.fechaTexto }}</div>
        </div>
        <div class="hist-stars">
          <i
            *ngFor="let s of [1,2,3,4,5]"
            class="fa-star"
            [class]="s <= h.estrellas ? 'fa-solid fa-star star-on' : 'fa-regular fa-star star-off'"
          ></i>
        </div>
      </div>
    </div>
  </section>

  <!-- ================== FAVORITOS ================== -->
  <section class="fav-card-outer">

    <div class="fav-header">
      <div class="fav-header-icon">
        <i class="fa-solid fa-heart"></i>
      </div>
      <span class="fav-header-title">Mis favoritos</span>
      <span class="fav-count" *ngIf="favoritos.length > 0">
        {{ favoritos.length }} lugar{{ favoritos.length !== 1 ? 'es' : '' }}
      </span>
    </div>

    <div class="fav-list">

      <p *ngIf="loadingFavoritos" class="fav-loading">Cargando favoritos...</p>

      <div *ngIf="!loadingFavoritos && favoritos.length === 0" class="fav-empty">
        <span class="fav-empty__icon"><i class="fa-solid fa-heart"></i></span>
        <p>Aún no tienes lugares favoritos.</p>
        <small>Explora y guarda los que más te gusten.</small>
      </div>

      <div
        class="fav-item"
        *ngFor="let fav of favoritos"
        (click)="irADetalle(fav)"
      >
        <div class="fav-thumb">
          <img *ngIf="fav.imagenUrl" [src]="fav.imagenUrl" [alt]="fav.nombre" />
          <span *ngIf="!fav.imagenUrl" class="fav-thumb__initial">
            {{ fav.nombre[0] | uppercase }}
          </span>
        </div>
        <div class="fav-info">
          <div class="fav-name">{{ fav.nombre }}</div>
          <div class="fav-dir">
            <i class="fa-solid fa-location-dot"></i> {{ fav.direccion || '—' }}
          </div>
        </div>
        <button
          class="btn-quitar"
          type="button"
          (click)="$event.stopPropagation(); eliminarFavorito(fav)"
          [title]="'Quitar ' + fav.nombre + ' de favoritos'"
        >
          <i class="fa-solid fa-heart"></i>
        </button>
      </div>

    </div>
  </section>

</div>

<app-footer></app-footer>